import { Box } from '@mui/material';
import React, { FC, useMemo } from 'react';
import { BhiDialog } from 'src/UIKit';
import { FormView } from 'src/components/FormPart/FormView';
import { FormErrorRecord } from 'src/components/FormPart/types';
import { AutomationFormDialogController } from '../../controllers/AutomationFormDialogController';
import { AutomationFormData } from '../../types';
import { AutomationForm, AutomationFormProps } from './AutomationForm';

interface AutomationFormDialogProps extends AutomationFormDialogController {
  options: Omit<AutomationFormProps, 'onCancel'>;
}

export const AutomationFormDialog: FC<AutomationFormDialogProps> = props => {
  const { isOpen, close, initFormData, error, submit, options } = props;

  const errorList: FormErrorRecord<AutomationFormData>[] | undefined = useMemo(() => {
    if (error?.error === 'conflict') {
      return [{ field: 'name', message: 'Entity with this name already exists' }];
    }
  }, [error]);

  return (
    <BhiDialog
      isOpen={isOpen}
      onClose={close}
      title={initFormData?.id ? 'Edit Automation' : 'Create Automation'}
      maxWidth="md"
      fullWidth
    >
      {initFormData && (
        <Box px={2.5} pb={2.5}>
          <FormView
            formData={initFormData}
            component={AutomationForm}
            componentProps={{ ...options, onCancel: close }}
            errorList={errorList}
            onSubmit={full => submit(full)}
          />
        </Box>
      )}
    </BhiDialog>
  );
};
